export default __webpack_public_path__ + "static/media/logo-color-dark.29356b39.svg";